<ngx-spinner></ngx-spinner>
<div class="detail-box" [ngClass]="isActive || profileService.isActive ? 'active-mobile' : ''">
  <!-- <div class="mobile_head">
    <a href="JavaScript:void(0)" (click)="remove()" class="back_link">
      <span class="icon-arrow-left"></span>
    </a>
    <h4>{{ "MYPROFILE.ABOUT_ME" | translate }}</h4>
  </div> -->
  <div class="account-body">
    <div class="profile circle big-profile">
      <img src="{{ data?.image }}" (error)="errorHandler($event)" />
    </div>
    <div class="profile-detail w-100">
      <div class="row">
        <p class="w-100 px-3 name-lable" *ngIf="data?.name">
          <!-- <b>{{ "MYPROFILE.USER_NAME" | translate }} </b> -->
          {{ data?.name | titlecase }}
        </p>
        <p class="w-100 px-3" *ngIf="data?.email">
          <!-- <b>{{ "MYPROFILE.EMAIL" | translate }}</b> -->
          {{ data?.email }}
        </p>
        <p class="w-100 px-3" *ngIf="data?.mobile_number">
          <!-- <b>{{ "MYPROFILE.MOBILE" | translate }} </b> -->
          <span *ngIf="data?.country_code">+</span>
          <span>{{ data?.country_code }}{{ data?.mobile_number }}</span>
        </p>
        <div class="other-label">
          <p class="w-100 px-3 other-details" *ngIf="data?.gender">
            <b>{{ "MYPROFILE.GENDER" | translate }} </b>
            <span> {{ data?.gender | titlecase }}</span>
          </p>
          <p class="w-100 px-3 other-details" *ngIf="data?.date_of_birth">
            <b>{{ "MYPROFILE.DATE_OF_BIRTH" | translate }} </b>
            <span>{{ data?.date_of_birth | date: appConstant.dobFormat }}</span>
          </p>
        </div>
        <div class="pt-4 col-md-12 btn-div">
          <button (click)="openDialog()" class="btn btn-theme mr-2">
            {{ "MYPROFILE.EDIT_PROFILE" | translate }}
          </button>

          <button [routerLink]="['/manage-profile/watch']" class="btn btn-theme">
            {{ "MYPROFILE.MANAGE_PROFILE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>